import React, { memo } from 'react';
import ReactMarkdown from 'react-markdown';

export const MemoizedReactMarkdown = memo(ReactMarkdown);
